module.exports = __webpack_public_path__ + "img/sticker-nye-darkfans-es.f0a687d9.svg";